export { OriginIcon } from "./OriginIcon";
export { OriginIconProps } from "./OriginIcon";
export { OriginIcon as default } from "./OriginIcon";
